import { Avatar, Box, Card, Typography } from "@mui/material";
import { isFemaleGender } from "../../../pets/utils/Functions";
import { getFirstLetter } from "../../../../components/display/EntityCard";
import { useNavigate } from "react-router-dom";
import { petViewUrl } from "../../../../enums/UrlPaths";
import useUser from "../../../../hooks/useUser";
import usePrimaryColor from "../../../../hooks/usePrimaryColor";
import usePetAvatar from "../../../../hooks/usePetAvatar";
import { trimText } from "../../../../utils/Functions";

export default function PetListCard({ pet,minWidthInSm="90px", testId }) {
  const navigate = useNavigate();
  const { profile } = useUser();
  const blueColor = usePrimaryColor();
  const pinkColor = "hotpink";
  function goToPet() {
    navigate(petViewUrl(pet.id, profile.id));
  }
  const avatarBgColor = Boolean(pet.deceased)
    ? "gray"
    : isFemaleGender(pet.gender)
    ? pinkColor
    : blueColor;
  const { avatar, isLoading, error } = usePetAvatar(pet.id);

  return (
    <Card
      variant="outlined"
       data-testid={testId}
      onClick={() => goToPet()}
      sx={{
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        pt: 2,
        pb: 1.5,
        minHeight: 88,
        minWidth: { sm: { minWidthInSm } },
        cursor: "pointer",
        "&:hover": {
          border: `2px solid ${avatarBgColor}`,
        },
      }}
    >
      <Avatar
        src={avatar}
        sx={{
          mr: 1,
          color: "white",
          bgcolor: avatarBgColor,
          height: 47,
          width: 47,
        }}
        slotProps={{
          img: {
            sx: {
              filter: pet.deceased
                ? "grayscale(100%) brightness(0.8) contrast(0.95)"
                : "none",
            },
          },
        }}
      >
        {getFirstLetter(pet.name)}
      </Avatar>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {trimText(String(pet.name), 22)}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {pet.type?.title || "Unknown"}
        </Typography>
      </Box>
    </Card>
  );
}
